import { render, staticRenderFns } from "./StepContainer.vue?vue&type=template&id=afdac012&"
import script from "./StepContainer.vue?vue&type=script&lang=ts&"
export * from "./StepContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports